<template>
	<div v-if="hrDocument" style="max-width: 960px; padding: 12px">
		<v-card>
			<v-toolbar card prominent>
				<v-toolbar-title class="body-2 grey--text"></v-toolbar-title>

				<v-spacer></v-spacer>

				<v-tooltip v-if="$_hasAccessToFeature($FeatureId.COMPANY_POLICIES_MANAGE, $PermissionAction.USE)" bottom>
					<template v-slot:activator="{ on }">
						<v-btn icon v-on="on" @click="viewCompliantEmployeesClick">
							<v-icon>mdi-account-multiple-check</v-icon>
						</v-btn>
					</template>
					<span>View {{ $term('employee', { plural: true, case: 'title' }) }} who have agreed to this Policy</span>
				</v-tooltip>

				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-chip color="indigo" dark v-on="on"> V.{{ hrDocument.versionNo }} </v-chip>
					</template>
					<span>Document Version: {{ hrDocument.versionNo }}</span>
				</v-tooltip>
			</v-toolbar>
			<v-card-text>
				<div v-if="!isPdf" class="header">
					<v-layout row wrap>
						<v-flex md3 class="text-xs-left">
							<div class="logo">
								<img :src="loggedInTenant.logoUrl" />
							</div>
						</v-flex>

						<v-flex md6 class="mt-3" style="text-align: center">
							<h1>{{ hrDocument.name }}</h1>
						</v-flex>

						<v-flex md3 class="text-xs-left mt-3">
							<div class="header-right info-text">
								<div>Version: {{ hrDocument.versionNo }}</div>
								<div v-if="hrDocument.lastUpdatedDateUTC" class="info-text">Last Updated: {{ hrDocument.lastUpdatedDateUTC | formatDate }}</div>
								<div v-else class="info-text">Created: {{ hrDocument.createdDateUTC | formatDate }}</div>
							</div>
						</v-flex>
					</v-layout>
				</div>

				<div class="content">
					<div v-if="!isPdf" v-html="populatePlaceholders(hrDocument.content)"></div>

					<div v-else>
						<div v-if="isLoadingPdf" class="text-xs-center">
							<v-progress-circular indeterminate color="primary"></v-progress-circular>
						</div>
						<div v-else>
							<vue-pdf-embed :source="pdfDocSrc" style="display: inline-block; width: 100%"></vue-pdf-embed>
						</div>
					</div>
				</div>
				<div class="footer"></div>
			</v-card-text>
		</v-card>

		<employee-agreements-dialog v-if="agreementsDialog" :dialog="agreementsDialog" :agreements="hrDocument.agreements" @onCancel="onCancelAgreementsDialog" />
	</div>
</template>

<script>
	import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
	import employeeAgreementsDialog from '@/components/hrDocuments/EmployeeAgreementsDialog';
	import hrDocumentMixin from '@/mixins/hrDocumentMixin';

	export default {
		name: 'HrDocument',
		props: {
			hrDocument: {
				required: true,
				type: Object
			},
			loggedInTenant: {
				required: true,
				type: Object
			},
			isAdmin: {
				type: Boolean,
				required: true
			}
		},
		components: {
			VuePdfEmbed,
			employeeAgreementsDialog
		},
		data() {
			return {
				pdfDocSrc: null,
				pdfDocNumPages: undefined,
				isLoadingPdf: false,
				agreementsDialog: false
			};
		},
		created() {
			if (this.hrDocument && this.hrDocument.contentType === 1) {
				this.loadFile();
			}
		},
		computed: {
			isPdf() {
				return this.hrDocument.contentType == 1;
			}
		},
		methods: {
			loadFile() {
				this.isLoadingPdf = true;
				this.$store.dispatch('hrDocuments/getHrDocumentFileByVersion', { hrDocumentId: this.hrDocument.hrDocumentId, versionNo: this.hrDocument.versionNo }).then(response => {
					const documentLoadingTask = VuePdfEmbed.getDocument(window.URL.createObjectURL(new Blob([response.data])));
					documentLoadingTask.promise.then(pdf => {
						this.pdfDocSrc = pdf;
						this.isLoadingPdf = false;
						this.pdfDocNumPages = pdf._pdfInfo.numPages;
					});
				});
			},
			viewCompliantEmployeesClick() {
				this.agreementsDialog = true;
			},
			onCancelAgreementsDialog() {
				this.agreementsDialog = false;
			},
			printClick() {
				window.print();
			}
		},
		mixins: [hrDocumentMixin]
	};
</script>

<style scoped>
	.header {
		min-height: 100px;
		margin-bottom: 25px;
	}
	.header .header-right {
		text-align: right;
	}
	.header h1 {
		font-size: 1.7em;
	}
	.content {
		text-align: left;
	}
	.info-text {
		color: rgba(0, 0, 0, 0.54);
		font-size: 12px;
		font-style: italic;
	}
	.logo img {
		max-height: 100px;
		max-width: 220px;
	}
</style>
